import { layoutModeChanged } from 'features/layout/features/config/configSlice';
import { selectSystemSessionLayoutMode } from 'features/layout/features/config/systemSessionSelectors';
import { contentWidthChanged } from 'features/layout/features/contentDimensions/contentDimensionsSlice';
import { LayoutMode } from 'features/layout/types';
import { call, put, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { layoutConfig } from 'utils/layout';

export function* startRestreamerSaga() {
  const targetMode: LayoutMode | null = yield select(selectSystemSessionLayoutMode);
  if (targetMode) {
    yield put(layoutModeChanged(targetMode));
  }

  yield put(contentWidthChanged(layoutConfig.maxContentWidth));

  yield call(SignalingSocket.send, {
    event: 'restreamingStarted',
  });
}
